import chineseMessages from "@haxqer/ra-language-chinese";

const orderFields = {
  "contact.id": "客户ID",
  customerName: "客户",
  "contact.remarks": "联系人备注",
  status: "状态",
  shippingOption: "配送方式",
  merchandiseTotal: "商品总额",
  outstandingPayment: "未付金额",
  weight: "重量",
  shippingPostcode: "邮政编码",
  currencyCode: "币种",
  deliveryOrderPrinted: "送货单已打印",
  createdAt: "创建时间",
  updatedAt: "更新时间",
  email: "邮箱",
  description: "订单描述",
  notes: "客户备注",
  invoiceNumber: "发票号",
  orderNumber: "订单号",
  overrideShippingCost: "运费已覆盖",
  shippingAddress1: "收货地址1",
  shippingAddress2: "收货地址2",
  shippingCity: "收货城市",
  shippingCost: "运费",
  shippingCountry: "收货国家",
  shippingName: "收货人姓名",
  shippingPhoneNumber: "收货人电话",
  shippingProvince: "收货省份",
  shippingState: "收货州/省",
  shippingSubDistrict: "收货区/街道",
  shippingVillage: "收货村/小区",
  trackingNumber: "快递单号",
};

const customChineseMessages = {
  ...chineseMessages,
  pos: {
    search: "搜索",
    configuration: "设置",
    language: "语言",
    settings: {
      billing: "付款",
      accounts: "账户",
      settings: "设置",
      logout: "登出",
      plan_expired: "系统已过期",
      panel: {
        shipping_rules: "运输规则",
        important_info: "重要信息",
        parameters: "参数",
        pin_comment_template: "置顶评论模板",
        payment_msg: "付款信息",
        order_notification: "订单通知",
        shipped_notification: "已发货通知",
        self_collect_notification: "自取通知",
        webstore: "网店",
        payment_methods: "付款方式",
        marketing_messages: "营销信息",
        shipping_profiles: "运输配置",
        ninjavan: "Ninja Van",
        tnc: "条款和条件",
        privacy_policy: "隐私条款",
        shipping_policy: "运输条款",
        refund_policy: "退款条款",
        about_us: "关于我们",
        contact_us: "联系我们",
        gpt_settings: "GPT设置",
        bukku_settings: "Bukku设置",
      },
      important_info: {
        profile_settings: "账户设置",
        message_template: "消息模板",
        change_logo: "更改Logo",
        message_editor: "消息编辑器",
        preview: "预览",
        save_button: "保存",
        insert_image: "插入图片",
        save_template: "保存模板",
      },
      parameters: {
        settings_configuration: "设置配置",
        do_invoice_fields: "DO & Invoice 设置",
        delivery_order_shows_price: "Delivery order 显示价钱",
        delivery_order_hides_unit_price: "Delivery order 隐藏单价",
        delivery_order_show_total_weight: "Delivery order 显示总重量",
        delivery_order_use_invoice_label: "Delivery order 使用Invoice 标签",
        delivery_order_show_order_number_barcode:
          "Delivery order 显示订单编号条形码",
        invoice_show_order_number_barcode: "Invoice 显示订单编号条形码",
        show_image_in_do_inv: "在DO/INV中显示图片",
        enable_thermal_receipt: "启用热敏收据",
        sort_items_alphabetically: "Items按字母顺序排序",
        waitlists: "Waitlists",
        enable_waitlists: "启用Waitlists",
        general_settings: "参数",
        date_format: "日期格式",
        default_country_code: "默认国家代码",
        currency: "货币",
        shipping_countries: "运输国家",
        shipping_countries_description:
          "选择运输国家。默认情况下，所有国家都可以使用运输服务。",
        shipping_countries_placeholder: "选择国家",
        shipping_countries_helper_text: "",
        // likes_comment_order_successfully:
        //   "Likes comment order successfully. CAUTION: FB might block account or terminate Live videos, use at your own risk.",
        likes_comment_order_successfully:
          "点赞评论订单成功。注意：FB可能会限制你的主页，请自行承担风险。",
        enable_live_bidders_name_list_every_3_minutes:
          "启用每3分钟直播得标者名单",
        enable_hide_comment_upon_successful_bid: "启用成功得标后隐藏评论",
        enable_shopping_cart: "启用购物车",
        enable_customer_cancel: "启用客户取消",
        disable_customer_special_notes: "禁用客户特殊备注",
        enable_web_shop: "启用网店",
        enable_web_store_display_out_of_stock_products: "启用网店显示缺货产品",
        enable_capture_message: "启用捕获消息",
        order_notification_shows_unit_price: "订单通知显示单价",
        disable_order_notification_message_on_messenger:
          "禁用在Messenger中订单通知消息",
        enable_out_of_stock_notification: "启用缺货通知",
        allow_admin_delete_orders: "允许管理员删除订单",
        allow_to_edit_completed_orders: "允许编辑已完成订单",
        allow_manual_add_item_with_inactive_keyword:
          "允许手动添加不活跃的关键词",
        only_admin_can_edit_credit: "只有管理员可以编辑信用",
        disable_sell_on_ig: "禁用IG销售",
        disable_assistant_from_viewing_sales_table_in_live_window:
          "禁用助理查看销售表在直播窗口中",
        disable_tracking_plugin: "禁用跟踪插件",
        enable_credit_payment: "启用信用支付",
        enable_fake_cancel_message_on_status_locked:
          "启用状态为锁定时的假取消消息",
        enable_show_weight_in_shopping_cart: "启用显示重量在购物车中",
        disable_shipping_notification_message: "禁用运输通知消息",
        disable_manual_force_send_shopping_cart: "禁用手动强制发送购物车",
        allow_forcefully_send_shipping_message: "允许强制发送运输消息",
        keywordsessionQuantityValidationSeconds: "关键字最高限制时间(秒)",
      },
      webstore: {
        add_shop_now_button: "添加Shop Now按钮",
        add_shop_now_button_description:
          "复制下面的链接并按照说明将其设置为你的Shop Now按钮。",
        copy_webstore_link: "复制网店链接",
        add_get_started_button: "添加Get Started按钮",
        add_webstore_link: "添加网店链接",
        add_webstore_link_description: "添加网店链接",
        welcome_message_template: "欢迎消息模板",
        add_get_started_button_to_messenger: "添加Get Started按钮到Messenger",
        add_get_started_button_to_messenger_description:
          "你必须有“Get Started”按钮让新用户看到网店。", //When new conversation not able to view webstore, you need a Get Started button. Follow steps below.
        add_get_started_button_to_messenger_step_1: "点击“Check”",
        add_get_started_button_to_messenger_step_2:
          "如果按钮不存在，点击“Add Get Started”",
      },
    },
    dashboard: {
      today_sales: "今日销售",
      monthly_revenue: "月收入",
      pending_revenue: "待定收入",
      month_history: "近30天收入历史",
      new_orders: "新订单",
      pending_reviews: "待审核评论",
      new_customers: "新客户",
      pending_orders: "待处理订单",
      order: {
        items:
          "由 %{customer_name}，1个物品 |||| 由 %{customer_name}，%{nb_items}个物品",
      },
      welcome: {
        title: "欢迎使用Boxify FB Live系统",
        subtitle: "",
        aor_button: "有问题？尝试帮助中心",
        button2: "联系我们",
      },
    },
    menu: {
      sales: "销售",
      catalog: "目录",
      customers: "客户",
    },
  },
  resources: {
    contacts: {
      name: "客户",
      fields: {
        name: "姓名",
        channel: "渠道",
        phoneNumber: "电话号码",
        isBlacklisted: "拉黑",
        remarks: "备注",
        rating: "评分",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    orders: {
      name: "全订单",
      fields: orderFields,
    },
    activeorders: {
      name: "活跃",
      //fields: orderFields,
      fields: orderFields,
    },
    paidorders: {
      name: "已付款",
      fields: orderFields,
    },
    waitingforpaymentorders: {
      name: "待付款",
      fields: orderFields,
    },
    "ready-to-ship-orders": {
      name: "待发货",
      fields: orderFields,
    },
    payments: {
      name: "付款记录",
      fields: {
        "order.customerName": "客户",
        "order.shippingName": "收件人",
        "order.orderNumber": "订单号",
        "order.status": "订单状态",
        type: "付款类型",
        paidAmount: "金额",
        "order.invoiceNumber": "发票号",
        remarks: "备注",
        paid: "已付款",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    orderItems: {
      name: "订单商品",
      fields: {
        description: "商品描述",
        "keyword.key": "关键词",
        "order.customerName": "客户",
        channel: "渠道",
        status: "状态",
        price: "价格",
        "order.status": "订单状态",
        tags: "标签",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    keywords: {
      name: "关键词",
      fields: {
        description: "商品描述",
        key: "关键词",
        sku: "SKU",
        isActive: "启用",
        currencyCode: "货币",
        price: "价格",
        tieredPrices: "阶梯价格",
        webTieredPrices: "网站阶梯价格",
        webPrice: "网站价格",
        stock: "库存",
        stockLeft: "剩余库存",
        vipTier: "会员等级",
        allowBackorder: "允许缺货下单",
        weight: "重量(公斤)",
        cost: "成本",
        detail: "详情",
        allowInWeb: "允许在网站显示",
        categories: "分类",
        variants: "属性",
        minQuantity: "最小订购量",
        maxQuantity: "最大订购量",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    webstore: {
      name: "网店",
    },
    categories: {
      name: "分类",
      fields: {
        description: "描述",
        label: "标签",
        position: "排序",
        allowInWeb: "允许在网站显示",
        createdAt: "创建时间",
        updatedAt: "更新时间",
        selections: "规格项",
      },
    },
    variants: {
      name: "规格值",
      fields: {
        description: "描述",
        label: "标签",
        colorCode: "颜色",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    selections: {
      name: "规格项",
      fields: {
        description: "描述",
        label: "标签",
        variants: "属性",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    others: {
      name: "其他",
    },
    tools: {
      name: "工具",
    },
    vouchers: {
      name: "优惠券",
      fields: {
        code: "优惠码",
        value: "面值",
        isActive: "启用",
        discountType: "折扣类型",
        discountAfterShipping: "折扣包含运费",
        maxDiscount: "最大折扣额",
        minPurchaseAmount: "最低消费金额",
        maxUsage: "最大使用次数",
        maxUsagePerCustomer: "每位客户最大使用次数",
        usedCount: "已使用次数",
        expiredAt: "到期时间",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    tags: {
      name: "标签",
      fields: {
        description: "描述",
        label: "标签",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    waitlists: {
      name: "等候清单",
      fields: {
        "contact.name": "客户",
        description: "描述",
        key: "关键字",
        quantity: "数量",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    exports: {
      name: "导出",
      fields: {
        _id: "编号",
        params: "导出参数",
        recordCount: "记录数量",
        status: "状态",
        download: "下载",
        username: "用户",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
    creditlogs: {
      name: "积分记录",
      fields: {
        "contact.name": "客户",
        amount: "金额",
        "updatedBy.username": "更新人",
        createdAt: "创建时间",
        updatedAt: "更新时间",
      },
    },
  },
};

export default customChineseMessages;
